import React from 'react';
import ReactMarkdown from "react-markdown";

const MarkdownSnippet = (props) => (
    <ReactMarkdown
        children={props.content}
        className={props.className}
        disallowedElements={["a", "p", "em", "img", "li", "ol", "strong", "ul"]}
        skipHtml
        unwrapDisallowed
    />
);

export default MarkdownSnippet;
